import script from "./TopLine.vue?vue&type=script&setup=true&lang=js"
export * from "./TopLine.vue?vue&type=script&setup=true&lang=js"

import "./TopLine.vue?vue&type=style&index=0&id=531770bd&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531770bd"]])

export default __exports__